"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MiniMessage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var styled_1 = require("@hiyllo/ux/styled");
var moment_1 = __importDefault(require("moment"));
var omni_images_1 = require("@hiyllo/omni-images");
var message_text_content_1 = require("./message-text-content");
var Header = (0, styled_1.styledRN)(react_native_1.View, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    marginBottom: 5
});
var SenderName = (0, styled_1.styledRN)(react_native_1.Text, function (_a) {
    var $theme = _a.$theme;
    return ({
        color: $theme.foreground,
        fontSize: 15,
        fontWeight: "bold",
        fontFamily: 'hiyllo'
    });
});
var SentTime = (0, styled_1.styledRN)(react_native_1.Text, function (_a) {
    var $theme = _a.$theme;
    return ({
        color: $theme.foreground,
        fontSize: 10,
        fontWeight: "normal",
        fontFamily: 'hiyllo'
    });
});
exports.MiniMessage = react_1["default"].memo(function MiniMessage(props) {
    var _a;
    var content = props.message.content;
    if (content.encrypted) {
        return (0, jsx_runtime_1.jsx)(react_native_1.View, {});
    }
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)(omni_images_1.UserImage, { userId: props.message.senderId, width: 20 }), (0, jsx_runtime_1.jsx)(SenderName, { children: props.message.senderName }), (0, jsx_runtime_1.jsx)(SentTime, { children: (0, moment_1["default"])(props.message.sentDate).format("h:mm a, dddd MMM Do") })] }), content.image != null && ((_a = props.message) === null || _a === void 0 ? void 0 : _a.uuid) != null ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(omni_images_1.MessageImage, { messageUUID: props.message.uuid, imageContent: content.image, maxWidth: react_native_1.Dimensions.get('window').width * 0.25, maxHeight: 150 }) })) : null, (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(message_text_content_1.MessageTextContent, { content: content }) })] }));
});
